import React,
{
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  styled,
  alpha,
} from '@mui/material/styles';
import {
  InputBase,
} from '@mui/material';
import { debounce } from 'lodash';

import { useChatContext } from 'stream-chat-react';

import { useSelector } from 'react-redux';
import { channelByUser } from './utils';
import { ResultsDropdown } from './ResultsDropdown';

import SearchIcon from '@mui/icons-material/Search';

export const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.25) },
  marginLeft: 0,
  width: '100%',
}));
export const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  fontSize: '.8rem',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
  },
}));

export const ChannelSearch = () => {
  const {
    client,
    setActiveChannel,
  } = useChatContext();

  const selectedBarn = useSelector((state) => state.barn.selectedBarn)

  const [allChannels, setAllChannels] = useState();
  const [teamChannels, setTeamChannels] = useState();
  const [directChannels, setDirectChannels] = useState();

  const [focused, setFocused] = useState();
  const [focusedId, setFocusedId] = useState('');
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'ArrowDown') {
        setFocused((prevFocused) => {
          if (prevFocused === undefined || allChannels === undefined) return 0;
          return prevFocused === allChannels.length - 1
            ? 0
            : prevFocused + 1;
        });
      } else if (event.key === 'ArrowUp') {
        setFocused((prevFocused) => {
          if (prevFocused === undefined || allChannels === undefined) return 0;
          return prevFocused === 0
            ? allChannels.length - 1
            : prevFocused - 1;
        });
      } else if (event.key === 'Enter') {
        event.preventDefault();

        if (allChannels !== undefined && focused !== undefined) {
          const channelToCheck = allChannels[focused];

          if (channelToCheck.cid !== undefined) {
            setActiveChannel(channelToCheck);
          } else {
            channelByUser({
              client,
              setActiveChannel,
              user: channelToCheck,
            });
          }
        }

        setFocused(undefined);
        setFocusedId('');
        setQuery('');
      }
    },
    [allChannels, client, focused, setActiveChannel],
  );

  useEffect(() => {
    if (query) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown, query]);

  useEffect(() => {
    if (!query) {
      setTeamChannels([]);
      setDirectChannels([]);
    }
  }, [query]);

  useEffect(() => {
    if (focused && focused >= 0 && allChannels) {
      setFocusedId(allChannels[focused].id || '');
    }
  }, [allChannels, focused]);

  const setChannel = (
    channel,
  ) => {
    setQuery('');
    setActiveChannel(channel);
  };

  const getChannels = async (text) => {
    try {
      console.log(client.userID)
      const channelResponse = client.queryChannels(
        {
          type: 'team',
          name: { $autocomplete: text },
          members: { $in: [client.userID] },
        },
        {},
        { limit: 5 },
      );

      const userResponse = client.queryUsers(
        {
          id: { $ne: client.userID || '' },
          $and: [
            { name: { $autocomplete: text } },
          ],
          teams: { $contains: selectedBarn.tenant },
        },
        { id: 1 },
        { limit: 5 },
      );

      const [channels, { users }] = await Promise.all([channelResponse, userResponse]);

      if (channels.length) setTeamChannels(channels);
      if (users.length) setDirectChannels(users);
      setAllChannels([...channels, ...users]);
    } catch (event) {
      setQuery('');
      console.error(event)
    }

    setLoading(false);
  };

  const getChannelsDebounce = debounce(getChannels, 100, { trailing: true });

  const onSearch = (event) => {
    event.preventDefault();

    setLoading(true);
    setFocused(undefined);
    setQuery(event.target.value);
    if (!event.target.value) return;

    getChannelsDebounce(event.target.value);
  };

  return (
    <div className="channel-search__container">
      <Search>
        <SearchIconWrapper>
          <SearchIcon sx={{ color: '#fff' }} />
        </SearchIconWrapper>
        <StyledInputBase
          value={query}
          sx={{ color: '#fff' }}
          onChange={onSearch}
          placeholder="Search..."
          inputProps={{ 'aria-label': 'search' }}
        />

        {query && (
          <ResultsDropdown
            teamChannels={teamChannels}
            directChannels={directChannels}
            focusedId={focusedId}
            loading={loading}
            setChannel={setChannel}
            setQuery={setQuery}
          />
        )}
      </Search>
    </div>
  );
};
